module.exports = __webpack_public_path__ + "img/11_paul_d.70842ef3.png";